// extracted by mini-css-extract-plugin
export var leftAlign = "_1m-2";
export var popper = "_1m-0";
export var subtitle = "_1m-1";